import { InjectionToken} from '@angular/core';
import { DataAnalyticsConfig } from './interfaces/all';

export const DataAnalyticsConfigService = new InjectionToken<DataAnalyticsConfig>('DataAnalyticsContent');
